import * as actionTypes from "../actions/actionTypes";

const initialState = {
  hmgSelected: undefined,
  hotelSelected: [],
  allHotels: false,
  pageCategoryValid: {
    section1: false,
    section2: false,
  },
  pageCategory: {
    valid: {
      section1: false,
      section2: false,
    },
    categoryList: [],
    replicateCategories: [],
  },
  pageReportList: {
    valid: {
      section1: false,
      section2: false,
    },
    errors: {
      daily: [],
      weekly: [],
      monthly: [],
      quarterly: [],
      asneeded: [],
    },
    frequecyList: [],
    reportList: [],
    alreadyExistReports: [],
    categoryList: [],
    daily: [],
    weekly: [],
    monthly: [],
    quarterly: [],
    asneeded: [],
  },
  pageReportOrder: {
    valid: {
      hmg: false,
      hotel: false,
    },
    reportList: [],
  },
};

export const reports = (state = initialState, action) => {
  let tempElem = {};
  switch (action.type) {
    default:
      return state;
  }
};

export default reports;
